import { render } from "./ShippingDetails.vue?vue&type=template&id=027c3907&scoped=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"

import "./ShippingDetails.vue?vue&type=style&index=0&id=027c3907&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027c3907"]])

export default __exports__